import React from 'react';

const Gallery = () => {
    return (
        <div className="pt-24 section-padding">
            <div className="container-custom max-w-4xl mx-auto">
                <h1 className="text-4xl md:text-5xl font-bold mb-6">Project <span className="gradient-text">Gallery</span></h1>
                <p className="text-gray-300 leading-relaxed">
                    A collection of our completed steel and infrastructure projects will be showcased here soon.
                </p>
            </div>
        </div>
    );
};

export default Gallery;
